import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from '../../components/ui/tooltip';
import { House, Gear, Users, Package } from '@phosphor-icons/react';
import { BundlesTab } from './BundlesTab';

/**
 * EcoPlus management page — adds a "Hydration Bundles" tab on top of the
 * shared Mobile App tab set (Overview / Configurations / App Users).
 */
export default function EcoPlusManagePage() {
  return (
    <div className="space-y-6" data-testid="ecoplus-manage-page">
      <div>
        <h1
          className="text-3xl font-bold text-[#1C1917] tracking-tight"
          style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
        >
          Ecoplus
        </h1>
      </div>

      <Tabs defaultValue="overview" className="w-full">
        <TooltipProvider delayDuration={150}>
          <TabsList className="bg-white border border-[#EDE6D8] rounded-lg p-1 h-auto inline-flex gap-1 w-auto">
            <Tooltip>
              <TooltipTrigger asChild>
                <TabsTrigger
                  value="overview"
                  className="data-[state=active]:bg-[#0A2540] data-[state=active]:text-white rounded-lg h-10 px-3 gap-2 text-sm"
                  data-testid="tab-ecoplus-overview"
                >
                  <House size={16} />
                  <span className="font-semibold" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>Overview</span>
                </TabsTrigger>
              </TooltipTrigger>
              <TooltipContent side="bottom" sideOffset={6}>Overview</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <TabsTrigger
                  value="bundles"
                  className="data-[state=active]:bg-[#0A2540] data-[state=active]:text-white rounded-lg h-10 px-3 gap-2 text-sm"
                  data-testid="tab-ecoplus-bundles"
                >
                  <Package size={16} />
                  <span className="font-semibold" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>Hydration Bundles</span>
                </TabsTrigger>
              </TooltipTrigger>
              <TooltipContent side="bottom" sideOffset={6}>Hydration Bundles</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <TabsTrigger
                  value="configurations"
                  className="data-[state=active]:bg-[#0A2540] data-[state=active]:text-white rounded-lg h-10 px-3 gap-2 text-sm"
                  data-testid="tab-ecoplus-configurations"
                >
                  <Gear size={16} />
                  <span className="font-semibold" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>Configurations</span>
                </TabsTrigger>
              </TooltipTrigger>
              <TooltipContent side="bottom" sideOffset={6}>Configurations</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <TabsTrigger
                  value="app-users"
                  className="data-[state=active]:bg-[#0A2540] data-[state=active]:text-white rounded-lg h-10 px-3 gap-2 text-sm"
                  data-testid="tab-ecoplus-app-users"
                >
                  <Users size={16} />
                  <span className="font-semibold" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>App Users</span>
                </TabsTrigger>
              </TooltipTrigger>
              <TooltipContent side="bottom" sideOffset={6}>App Users</TooltipContent>
            </Tooltip>
          </TabsList>
        </TooltipProvider>

        <TabsContent value="overview" className="mt-6" />
        <TabsContent value="bundles" className="mt-6"><BundlesTab /></TabsContent>
        <TabsContent value="configurations" className="mt-6" />
        <TabsContent value="app-users" className="mt-6" />
      </Tabs>
    </div>
  );
}
